<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { get_local_ip, real_id } from '../../../helpers/interface_helpers';
	import { getExtSensorsSettings } from '../../../helpers/ext_sensor_helpers';
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	import { valueOutOfRange } from '../../../helpers/utilities';
	import { getNumberInputConfig } from '../../../helpers/number_input_helpers';
	//Services
	import { localReq, postReq } from '../../../services/http';
	//Design system components
	import { Input, Button, Text } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../../types/Device';

	export let device: Device;

	let waitForResponse = false;

	const id = real_id(device.id),
		ext_humidity_settings = getExtSensorsSettings(device, 'humidity'),
		tname = 'offset',
		min = -50,
		max = 50,
		setOffset = async (sensor: any) => {
			waitForResponse = true;
			let res;
			const local_ip = get_local_ip(id),
				offset = sensor[tname];
			if (local_ip) {
				res = await localReq(
					device,
					`${local_ip}/settings/ext_humidity/${sensor.extid}`,
					'post',
					{ offset },
				);
			} else {
				res = await postReq(`/device/${device.category}/settings/humidity_offset`, {
					channel: device.channel,
					extid: sensor.extid,
					id: sensor.id,
					offset,
				});
			}
			onSettingsResponse(res, device);
			waitForResponse = false;
		};
</script>

{#each ext_humidity_settings as sensor}
	<Text styleType="body-small" class="mb-s">{sensor.name}</Text>
	<Input
		aria-label={$format('input_humidity_offset', {
			default: 'Input Humidity offset',
		})}
		{...getNumberInputConfig()}
		size="m"
		class="mb-s"
		icon="fas fa-calculator"
		value={sensor[tname]}
		error={valueOutOfRange(sensor[tname], min, max)
			? $format('min_max_error_description', {
					values: { min, max },
					default: 'Value must be between {min} and {max}.',
				})
			: ''}
		on:input={(e) => (sensor[tname] = e.target['value'])}
		id="input-fgpz7c4"
	/>
	<Button
		size="m"
		width="full"
		loading={waitForResponse}
		disabled={valueOutOfRange(sensor[tname], min, max)}
		on:click={() => setOffset(sensor)}>{$format('button_save', { default: 'Save' })}</Button
	>
{/each}
